import { getAxiosClient } from "../config/axios";

const getStoricoConfigurazioniBaseUrl = (endpoint) => {
  return `/api/v1/nng/storico-configurazioni${endpoint ?? ""}`;
};

const storicoConfigurazioniApiClient = {
  getStoricoConfigurazioniTableData: (params) => {
    return getAxiosClient().get(getStoricoConfigurazioniBaseUrl(), {
      params: params,
    });
  },
  exportCsv: (params) => {
    return getAxiosClient().get(
      getStoricoConfigurazioniBaseUrl(`/export-csv`),
      {
        responseType: "blob",
        params: params,
      }
    );
  },
  exportXls: (params) => {
    return getAxiosClient().get(
      getStoricoConfigurazioniBaseUrl(`/export-xls`),
      {
        responseType: "blob",
        params: params,
      }
    );
  },
  getStoricoConfigurazioniFilterData: (customerId) => {
    return getAxiosClient().get(
      getStoricoConfigurazioniBaseUrl(`/filter-data/${customerId}`)
    );
  },
};

export default storicoConfigurazioniApiClient;
